import { supabase } from '../supabaseClient';

export class DocumentService {
  // DOCUMENTS MANAGEMENT
  static async getDocumentsPaged({
    page = 1,
    pageSize = 20,
    submissionId,
    clientId,
    status,
    search,
    dateFrom,
    dateTo,
    sortBy = 'created_at',
    sortDir = 'desc'
  } = {}) {
    try {
      const from = Math.max(0, (page - 1) * pageSize);
      const to = from + pageSize - 1;
      let query = supabase
        .from('submission_documents')
        .select(`
          *,
          wizard_submissions!submission_id (
            id,
            first_name,
            last_name,
            personal_info
          )
        `, { count: 'exact' });

      if (submissionId) {
        query = query.eq('submission_id', submissionId);
      }
      if (clientId) {
        query = query.eq('client_id', clientId);
      }
      if (status && status !== 'all') {
        query = query.eq('status', status);
      }
      if (dateFrom) {
        query = query.gte('created_at', dateFrom);
      }
      if (dateTo) {
        query = query.lte('created_at', dateTo);
      }
      if (search && search.trim()) {
        const term = `%${search.trim()}%`;
        query = query.ilike('title', term);
      }

      const allowedSort = new Set(['created_at', 'updated_at', 'status', 'title']);
      const sortField = allowedSort.has(sortBy) ? sortBy : 'created_at';
      query = query.order(sortField, { ascending: String(sortDir).toLowerCase() === 'asc' });

      query = query.range(from, to);

      const { data, error, count } = await query;
      if (error) throw error;
      return { rows: data || [], count: count || 0 };
    } catch (error) {
      console.error('Error fetching paginated documents:', error);
      return { rows: [], count: 0 };
    }
  }
}
